import { useFieldContext } from "@bps/fluent-ui";
import { ChangeLogDto } from "@libs/api/types/common-dtos";

import {
  RolloutPackageDesiredConfigFormValues,
  RolloutPackageFormValues
} from "../../rollout/rolloutFormValues";
import { RolloutPackageConfigureDto } from "./";
import { RolloutPackageDesiredConfigFilter } from "./RolloutPackageDesiredConfigFilter";
import { RolloutPackageDesiredConfigForm } from "./RolloutPackageDesiredConfigForm";

export interface RolloutPackageConfigurationDto {
  softwarePackageVersionId: string;
  key: string;
  value: string;
  defaultValue: string;
  dataType: string;
  description: string;
  changeLog: ChangeLogDto;
}

interface EditRolloutPackageDesiredConfigProps {
  configureSoftwarePackage: RolloutPackageConfigureDto;
  onDismiss: () => void;
  onUpdate: (values: RolloutPackageDesiredConfigFormValues[]) => void;
  rolloutOccurred?: boolean;
}

export const EditRolloutPackageDesiredConfig = ({
  configureSoftwarePackage,
  onDismiss,
  onUpdate
}: EditRolloutPackageDesiredConfigProps) => {
  const { value: rolloutPackages } = useFieldContext<
    RolloutPackageFormValues[]
  >("rolloutPackages");

  return (
    <RolloutPackageDesiredConfigFilter>
      {({ values }) => {
        return (
          <RolloutPackageDesiredConfigForm
            configureSoftwarePackage={configureSoftwarePackage}
            filter={values}
            onDismiss={onDismiss}
            onUpdate={onUpdate}
            rolloutPackages={rolloutPackages ?? []}
          />
        );
      }}
    </RolloutPackageDesiredConfigFilter>
  );
};
